import getConfig from 'next/config';
import type { GetServerSidePropsContext } from 'next';
import { getCookie } from 'cookies-next';

const getServerSidePageLocale = ({
  req,
  res,
  locale,
}: GetServerSidePropsContext) => {
  const {
    publicRuntimeConfig: { defaultLocale },
  } = getConfig();

  const cookieNextLocale = getCookie('NEXT_LOCALE', { req, res });

  return locale || cookieNextLocale || defaultLocale;
};

export default getServerSidePageLocale;
